<template>
  <div>
    <Header />
    <intro-header
      v-if="this.$route.path !== '/' &&
        this.$route.path.toLowerCase() !== '/recuperar-registro' &&
        this.$route.path.toLowerCase() !== '/selecionar-paciente' &&
        this.$route.path.toLowerCase() !== '/redefinicao-de-senha' &&
        this.$route.path.toLowerCase() !== '/recuperacao-de-senha' ? true : false"
    />
    <slot />
    <div class="floating-buttons">
      <print-button />
      <helper-button />
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/shared/header/Header'
import Footer from '@/components/shared/footer/Footer'
import IntroHeader from '@/components/shared/header/IntroHeader'
import HelperButton from '@/components/shared/HelperButton'
import PrintButton from '@/components/shared/PrintButton'

export default {
  name: 'LayoutDefault',
  components: {
    Header,
    Footer,
    IntroHeader,
    HelperButton,
    PrintButton
  }
}
</script>

<style lang="scss" scoped>
.app-view{
  padding-bottom: 7rem;
}
.floating-buttons {
  position: fixed;
  top: 90%;
  right: 1.875rem;
  transform: translateY(-50%);
  z-index: 999;

  > div + div {
    margin-top: 1rem;
  }
}

</style>
